var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEllipseBigSliver(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 534,
    viewBox: "0 0 89 534",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.6098 143.17C69.1998 180.182 58.2195 222.309 58.2195 267C58.2195 311.691 69.1998 353.818 88.6098 390.83C43.9763 475.939 -45.2314 534 -148 534C-295.46 534 -415 414.46 -415 267C-415 119.54 -295.46 0 -148 0C-45.2314 0 43.9763 58.0611 88.6098 143.17ZM-148 409.033C-226.442 409.033 -290.033 345.442 -290.033 267C-290.033 188.558 -226.442 124.967 -148 124.967C-69.5576 124.967 -5.96741 188.558 -5.96741 267C-5.96741 345.442 -69.5576 409.033 -148 409.033Z",
    fill: "#3F81BA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipseBigSliver);
export default __webpack_public_path__ + "static/media/ellipse_big_sliver.e7dfb0056e08e8e3dfa05fb7d7ec554b.svg";
export { ForwardRef as ReactComponent };